import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText, Loader2 } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { settingsApi } from '../lib/api';

const TermsPage = () => {
  const [sections, setSections] = useState([]);
  const [lastUpdated, setLastUpdated] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const res = await settingsApi.getTerms();
      setSections(res.data.sections || []);
      setLastUpdated(res.data.last_updated || 'Febrero 2026');
    } catch (error) {
      console.error('Error fetching terms:', error);
    } finally {
      setLoading(false);
    }
  };

  // Render markdown-like content as HTML
  const renderContent = (content) => {
    if (!content) return '';
    return content
      .replace(/\*\*(.*?)\*\*/g, '<strong class="text-white">$1</strong>')
      .replace(/^- /gm, '<li class="ml-4">')
      .replace(/(<li[^>]*>.*?)(?=<li|$)/g, '$1</li>')
      .replace(/\n\n/g, '</p><p class="mt-3">')
      .replace(/\n/g, '<br/>');
  };

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <Navbar />
      
      <main className="pt-8 md:pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors mb-6"
            >
              <ArrowLeft size={16} />
              Volver al inicio
            </Link>
            
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-xl flex items-center justify-center">
                <FileText className="text-[#D4AF37]" size={24} />
              </div>
              <div>
                <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tight">
                  Términos y Condiciones
                </h1>
                <p className="text-[#71717A] text-sm">Última actualización: {lastUpdated}</p>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          {loading ? (
            <div className="flex items-center justify-center h-64">
              <Loader2 className="animate-spin text-[#D4AF37]" size={32} />
            </div>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="prose prose-invert prose-lg max-w-none"
            >
              <div className="space-y-8 text-[#A1A1AA]">
                {sections.map((section, index) => (
                  <section 
                    key={section.id || index}
                    className="bg-[#121212] border border-[#27272A] rounded-xl p-6 sm:p-8"
                  >
                    <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                      <span className="text-[#D4AF37]">{index + 1}.</span> {section.title}
                    </h2>
                    <div 
                      className="leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: renderContent(section.content) }}
                    />
                  </section>
                ))}
              </div>
            </motion.div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
